export default function (trackingConfig, maxDelayWait = 3000) {
    /*
    server side is sending default tracking values, for the page.
    on the client we decide which view to render (entitled, unentitled, etc)
    tracking values (ex.: product code) are different for these pages
    setting delayed tracking values (productCode, pageName) on the client for paywalls and mpls,
    need to wait for it to resolve,
    hence we need to delay reading tracking data until we have the information which page was rendered
    */
    return new Promise((resolve) => {
        let timeout;
        const finalStopTimeout = setTimeout(() => {
            resolve(false);
            clearTimeout(timeout);
        }, maxDelayWait);

        (function pCodeTimeout() {
            const delayedValues = trackingConfig.delayedValues;
            timeout = setTimeout(pCodeTimeout, 100);
            if (Object.keys(delayedValues).length) {
                clearTimeout(timeout);
                clearTimeout(finalStopTimeout);
                resolve(delayedValues);
            }
        }());
    });
}
